document.addEventListener("click", function(event) {
  if (event.target.matches("#brand_page .brands_list_title")) {
    if (window.innerWidth <= 1024) {
      var container = event.target.closest(".brands_list");
      var brandListUl = container.querySelector(".brand_list_ul");
      if (brandListUl.style.display === "none" || brandListUl.style.display === "") {
        brandListUl.style.display = "block";
      } else {
        brandListUl.style.display = "none";
      }
      event.target.classList.toggle("active");
    }
  }
});

const showNavMobile = document.querySelector(".show-nav-mobile");

if (showNavMobile) {
  showNavMobile.addEventListener("click", function() {
    var navWrapper = document.querySelector(".common-navigation-wrapper");
    navWrapper.classList.toggle('active');

  });
}
const commonNavigationClose = document.querySelector(".js-common-navigation-close");
if (commonNavigationClose) {
  commonNavigationClose.addEventListener("click", function() {
    var navWrapper = document.querySelector(".common-navigation-wrapper");
    navWrapper.classList.toggle('active');
  });
}

// Width Fit Finder
(function ($) {
  // Функція simply.countWide визначає ширину взуття на основі введених значень
  const simply = {};
  simply.countWide = function (isFemale, size, category) {
    var widthCategory,
        dataCollection = null,
        femaleSizes = {
          3: { "1e": { min: 212, max: 220 }, "2e": { min: 221, max: 229 }, "4e": { min: 230, max: 240 }, "6e": { min: 243, max: 255 } },
          4: { "1e": { min: 218, max: 223 }, "2e": { min: 224, max: 236 }, "4e": { min: 237, max: 248 }, "6e": { min: 249, max: 262 } },
          5: { "1e": { min: 224, max: 229 }, "2e": { min: 230, max: 242 }, "4e": { min: 243, max: 255 }, "6e": { min: 256, max: 268 } },
          6: { "1e": { min: 230, max: 236 }, "2e": { min: 237, max: 248 }, "4e": { min: 249, max: 261 }, "6e": { min: 262, max: 275 } },
          7: { "1e": { min: 237, max: 242 }, "2e": { min: 243, max: 255 }, "4e": { min: 256, max: 267 }, "6e": { min: 268, max: 281 } },
          8: { "1e": { min: 243, max: 248 }, "2e": { min: 249, max: 261 }, "4e": { min: 262, max: 274 }, "6e": { min: 275, max: 287 } },
          9: { "2e": { min: 256, max: 267 }, "4e": { min: 268, max: 280 }, "6e": { min: 281, max: 293 } },
        },
        maleSizes = {
          6: { "1e": { min: 228, max: 234 }, "2e": { min: 238, max: 255 }, "4e": { min: 256, max: 267 }, "6e": { min: 268, max: 280 } },
          7: { "1e": { min: 235, max: 243 }, "2e": { min: 244, max: 261 }, "4e": { min: 262, max: 273 }, "6e": { min: 274, max: 286 } },
          8: { "1e": { min: 240, max: 249 }, "2e": { min: 250, max: 267 }, "4e": { min: 268, max: 279 }, "6e": { min: 280, max: 292 } },
          9: { "1e": { min: 245, max: 252 }, "2e": { min: 256, max: 273 }, "4e": { min: 274, max: 285 }, "6e": { min: 286, max: 298 } },
          10: { "1e": { min: 255, max: 258 }, "2e": { min: 262, max: 279 }, "4e": { min: 280, max: 291 }, "6e": { min: 292, max: 304 } },
          11: { "1e": { min: 260, max: 264 }, "2e": { min: 268, max: 285 }, "4e": { min: 286, max: 297 }, "6e": { min: 298, max: 310 } },
          12: { "1e": { min: 265, max: 270 }, "2e": { min: 274, max: 291 }, "4e": { min: 292, max: 303 }, "6e": { min: 304, max: 316 } },
          13: { "1e": { min: 272, max: 276 }, "2e": { min: 277, max: 297 }, "4e": { min: 298, max: 309 }, "6e": { min: 310, max: 322 } },
          14: { "1e": { min: 278, max: 282 }, "2e": { min: 283, max: 286 }, "4e": { min: 287, max: 304 }, "6e": { min: 305, max: 328 } },
          15: { "1e": { min: 284, max: 288 }, "2e": { min: 288, max: 292 }, "4e": { min: 305, max: 309 }, "6e": { min: 328, max: 332 } },
          16: { "1e": { min: 285, max: 289 }, "2e": { min: 290, max: 294 }, "4e": { min: 308, max: 312 }, "6e": { min: 312, max: 315 } },
        };

    size = parseInt(size);
    if (isFemale) {
      // Отримуємо дані для жіночого взуття
      dataCollection = $(".width-fit-finder #browse-footwear-btn").attr("data-womancoll");
      // Перевіряємо розмір взуття в жіночій таблиці
      for (var prop in femaleSizes[category]) {
        if (size >= femaleSizes[category][prop].min && size <= femaleSizes[category][prop].max) {
          widthCategory = prop;
          break;
        }
      }
    } else {
      // Отримуємо дані для чоловічого взуття
      dataCollection = $(".width-fit-finder #browse-footwear-btn").attr("data-mencoll");
      // Перевіряємо розмір взуття в чоловічій таблиці
      for (var prop in maleSizes[category]) {
        if (size >= maleSizes[category][prop].min && size <= maleSizes[category][prop].max) {
          widthCategory = prop;
          break;
        }
      }
    }

    if (widthCategory !== null && widthCategory !== undefined) {
      if (dataCollection) {
        $("#browse-footwear-btn").show();
        $("#browse-footwear-btn a").attr("href", dataCollection);
      }
      $("#result-span").find(".result-span-final span").text(widthCategory);
      $("#result-span").show();
      $(".e-group." + widthCategory).addClass("active");
    }
  };

  $(document).ready(function () {

    // Оновлюємо значення діапазону при введенні
    $(document).on("input", ".range-group input.range-input", function () {
      var value = parseInt($(this).val()),
          min = parseInt($(this).attr("min")),
          max = parseInt($(this).attr("max")),
          percentage = (100 * (value - min)) / (max - min);

      if ($(this).hasClass("range-input-female")) {
        $(this).parent().find("span.range-input-female").text(value).css("left", percentage + "%");
      } else {
        $(this).parent().find("span.range-input-male").text(value).css("left", percentage + "%");
      }
    });

    // Змінюємо активний елемент при кліку на зображення
    $(document).on("click", ".multiple-choice li .que-img", function () {
      var currentGender = $(this).closest("ul").find("li.active").attr("data-gender") === "male",
          newGender = $(this).parent("li").attr("data-gender") === "male";

      if (currentGender === newGender) return false;

      $(".e-group").removeClass("active");
      $("#browse-footwear-btn, #result-span").hide();

      if (newGender) {
        $(".width-fit-finder .range-input-female").hide();
        $(".width-fit-finder .range-input-male").show();
        var menSrc = $(".video_img").attr("men-src");
        $(".video_img").attr("src", menSrc);
      } else {
        $(".width-fit-finder .range-input-female").show();
        $(".width-fit-finder .range-input-male").hide();
        var womenSrc = $(".video_img").attr("women-src");
        $(".video_img").attr("src", womenSrc);
      }

      $(this).parent("li").addClass("active").siblings("li").removeClass("active");
    });

    // Відкриття відео при кліку на кнопку гіда
    $(document).on("click", ".width-fit-finder .video-guide", function () {
      var videoSrc;

      if ($(".width-fit-finder").attr("data-page") === "width-fit-finder") {
        var isFemale = $(".width-fit-finder .multiple-choice").find("li.active").attr("data-gender") === "female";
        videoSrc = $("#guide-video").attr(isFemale ? "data-women-src" : "data-men-src");
      } else {

        videoSrc = $(this).find("iframe").attr("data-src");
      }

      // Відкриття fancybox з відеогідом
      $.fancybox({
        href: videoSrc,
        wrapCSS: 'iframe-guide-video',
        type: 'iframe',
        iframe: {
          preload: false
        },
        youtube: {
          autoplay: 1
        },
        helpers: {
          overlay: {
            css: {
              background: 'rgba(23, 23, 23, 0.85)'
            }
          }
        },
        afterShow: function () {}
      });
    });

    // Обробник подій для натискання кнопки відправлення результатів
    $(document).on("click", ".width-fit-finder .btn-submit-result", function () {
      var isFemale = $(".width-fit-finder .section-gender .multiple-choice li.active").attr("data-gender") == "female";
      var size = $(".width-fit-finder .section-width input.range-input-male").val();
      var category = $(".width-fit-finder .section-size input.range-input-male").val();


      if (isFemale) {
        size = $(".width-fit-finder .section-width input.range-input-female").val();
        category = $(".width-fit-finder .section-size input.range-input-female").val();
      }

      // Очищення активних класів та приховування кнопок
      $(".e-group").removeClass("active");
      $("#browse-footwear-btn").hide();

      // Визначення ширини на основі даних, введених користувачем
      simply.countWide(isFemale, size, category);
    });
  });
}(jQuery));
// END Width Fit Finder
// Customer Catalogue
(function ($) {
  const simply = {};
  simply.formSubmitHandle = function (form, url, formId) {
    simply.submitted_id = formId;
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: form.serialize()
    }).done(function (response) {
      if (response.result === "success") {
        switch (simply.submitted_id) {
          case "health_catalogue_form":
            window.location.href = "/pages/thank-you-for-request";
            break;
          case "taperequest-form-id":
            window.location.href = "/pages/measuring-tape-request-thank-you";
            break;
          default:
            window.location.href = "/pages/thank-you";
        }
      }
    });
  };

  simply.healthForm = function () {
    $("#health_catalogue_form").submit(function (event) {
      event.preventDefault();
      var formId = $(this).attr("id");
      simply.formSubmitHandle($(this), "https://script.google.com/macros/s/AKfycbx6knX5-Qr2WEXT64Hmi0xkLLjpUEUnESe0mJucKeRViq8kJ6A/exec", formId);
    });
  };

  simply.measuringForm = function () {
    $("#measuring_tape_page .tape_form").submit(function (event) {
      event.preventDefault();
      var formId = $(this).attr("id");
      simply.formSubmitHandle($(this), "https://script.google.com/macros/s/AKfycby74X3Ae3HU6i6zVu0Aw4dYQdbX7JPkPuOCBtmDaR6QtYEWnmhJ/exec", formId);
    });
  };

  simply.customerCatalog = function () {
    $("#customer_catalogue_form").submit(function (event) {
      event.preventDefault();
      var formId = $(this).attr("id");
      simply.formSubmitHandle($(this), "https://script.google.com/macros/s/AKfycbxBQ0gSKiNjFEINBXFLvQiJyX6exPGws62w7EnVlxeU4ax0XJo2BaEPB0JdwEQPCMXY/exec", formId);
    });
  };

  $(document).ready(function () {
    simply.healthForm();
    simply.measuringForm();
    simply.customerCatalog();
  });
})(jQuery);
// END Customer Catalogue
// FAQs
(function ($) {
  const simply = {};
  simply.initFaqPageEvent = function () {
    function handleFaqSearch() {
      var keyword = $(".faq-page .faq-input-holder #keyword").val().toLowerCase();
      $(".faq-page .search-error").toggle(keyword.length === 0);
      var found = false;
      $(".faq_listing .accordion-section").each(function () {
        var question = $(this).find(".faq-question").attr("data-search").toLowerCase();
        var content = $(this).find(".faq-content").text().toLowerCase();
        if (question.includes(keyword) || content.includes(keyword)) {
          found = true;
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $(".faq-page .search-not-found").toggle(!found);
    }

    $(document).on("click", ".faq-page .faq-button-holder button", function () {
      $("#faq-container .faq_listing .faq .accordion-section-content").stop().slideUp("fast");
      $(".accordion-section .accordion-section-title .fa").removeClass("fa-minus").addClass("fa-plus");
      handleFaqSearch();
    });

    $(document).on("keyup", ".faq-page .faq-input-holder input#keyword", function (event) {
      if ((event.which || event.keyCode) === 13) {
        $("#faq-container .faq_listing .faq .accordion-section-content").stop().slideUp("fast");
        $(".accordion-section .accordion-section-title .fa").removeClass("fa-minus").addClass("fa-plus");
        handleFaqSearch();
      }
    });
  };

  $(document).ready(function () {
    $(".site-nav--has-dropdown").hover(
        function () {
          $(".menu-overlay").stop().addClass("active-fade");
        },
        function () {
          $(".menu-overlay").stop().removeClass("active-fade");
        }
    );

    $(".accordion-section .accordion-section-title").click(function () {
      if (!$(this).hasClass("faq-question")) {
        $(".accordion-section-content").stop().slideUp("fast");
        var icon = $(this).find(".fa");
        $(".accordion-section .accordion-section-title .fa").not(icon).removeClass("fa-minus").addClass("fa-plus");
      }
      $(this).siblings(".accordion-section-content").stop().slideToggle("fast");
      $(this).children(".fa").toggleClass("fa-minus fa-plus");
    });

    $(".accordion-section-content").hover(
        function () {
          $(this).siblings(".accordion-section-title").addClass("active");
        },
        function () {
          $(this).siblings(".accordion-section-title").removeClass("active");
        }
    );

    if ($(".faq-page").length > 0) {
      simply.initFaqPageEvent();
      $(".faq_listing .accordion-section:not(.most-faq)").hide();
      /*
      $(".common-navigation-wrapper ul li").click(function () {
        $(".common-navigation-wrapper ul li a").removeClass("common-active").removeAttr("href");
        $(this).find("a").addClass("common-active");

        if ($(this).hasClass("delivery")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.delivery)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).hasClass("contact-us")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.contact)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).hasClass("reviews")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.review)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).hasClass("learn-the-widths")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.learn-width)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).hasClass("returns")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.returns)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).hasClass("most-faqs")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.most-faq)").hide();
          $(".search-not-found").addClass("hide-me");
        } else {
          $(".faq_listing .accordion-section").hide();
          $(".search-not-found").removeClass("hide-me");
        }
        $("html, body").animate({ scrollTop: 0 }, "fast");
      });

      $(".popular-tags li").click(function () {
        if ($(this).find("a").hasClass("delivery")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.delivery)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).find("a").hasClass("contact-us")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.contact)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).find("a").hasClass("reviews")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.review)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).find("a").hasClass("learn-the-widths")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.learn-width)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).find("a").hasClass("returns")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.returns)").hide();
          $(".search-not-found").addClass("hide-me");
        } else if ($(this).find("a").hasClass("most-faqs")) {
          $(".faq_listing .accordion-section").show();
          $(".faq_listing .accordion-section:not(.most-faq)").hide();
          $(".search-not-found").addClass("hide-me");
        } else {
          $(".faq_listing .accordion-section").hide();
          $(".search-not-found").removeClass("hide-me");
        }
        $("html, body").animate({ scrollTop: 0 }, "fast");
      });
       */
    }
  });
})(jQuery);
// END FAQs